export const iconColors = {
  color: "#403C6F",
  bgColor: "#ECECF1",
  borderColor: "#ECECF1",
  iconColor: "#403C6F",
};
